export default [
  {
    path: 'gestao/metas',
    name: 'metas',
    component: () => import('./index'),
    children: [],
    meta: {
      visible: false,
      title: 'Metas',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Gestão', link: 'gestao' },
        { name: 'Metas' }
      ]
    }
  },
]